import React, { useEffect, useContext, useState } from "react";
import { StoreContext } from "../../context/StoreContext";
import { ResultsList } from "../../components/componentsList";

if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    "use strict";

    if (search instanceof RegExp) {
      throw TypeError("first argument must not be a RegExp");
    }
    if (start === undefined) {
      start = 0;
    }
    return this.indexOf(search, start) !== -1;
  };
}

const Results = () => {
  const { state, actions } = useContext(StoreContext);
  const [results, setResults] = useState({
    list: [],
    loaded: false,
    resultStatus: "loading",
    landingspage: false,
  });

  useEffect(() => {
    switch (results.resultStatus) {
      case "loading":
        checkInputForResults();
        break;
      case "inputFound":
        checkForPlace();
        break;
      case "placeSet":
        if (state.results.latLong) {
          filterOnPlaceField();
        }
        break;
      case "placesFiltered":
        filterOnQualityScheme();
        break;
      case "qualitySchemeFiltered":
        filterOnCompanyField();
        break;
      case "allDone":
        checkQualitySchemes();
    }
  }, [
    state.results.resultStatus,
    state.results.searchInput,
    state.results.latLong,
    results.resultStatus,
  ]);

  function distance(lat1, lon1, lat2, lon2) {
    if (lat1 == lat2 && lon1 == lon2) {
      return 0;
    } else {
      var radlat1 = (Math.PI * lat1) / 180;
      var radlat2 = (Math.PI * lat2) / 180;
      var theta = lon1 - lon2;
      var radtheta = (Math.PI * theta) / 180;
      var dist =
        Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = (dist * 180) / Math.PI;
      dist = dist * 60 * 1.1515;
      dist = dist * 1.609344;
      return dist;
    }
  }

  function checkInputForResults() {
    if (document.querySelector("#prefilled-term")) {
      const searchTerm = document
        .querySelector("#prefilled-term")
        .innerText.trim();
      const a = state.search.suggestions.MappingKeywordAttribute.filter(
        (keyword) => keyword.Name === searchTerm
      );
      actions.setInputForResults([
        {
          company: {
            Name: searchTerm,
            searchCategory: "MappingKeywordAttribute",
            Id: a.length > 0 ? a[0].specialismeId : "",
          },
        },
      ]);

      sessionStorage.setItem(
        "TNLZSInput",
        JSON.stringify([
          {
            company: {
              Name: searchTerm,
              searchCategory: "MappingKeywordAttribute",
              Id: "",
            },
          },
        ])
      );

      setResults({
        ...results,
        resultStatus: "inputFound",
        landingspage: true,
      });
    } else {
      if (sessionStorage.getItem("TNLZSInput")) {
        actions.setInputForResults(
          JSON.parse(sessionStorage.getItem("TNLZSInput"))
        );
        setResults({
          ...results,
          resultStatus: "inputFound",
        });
      } else {
        actions.setResultStatus("noResults");
      }
    }
  }

  function filterOnCompanyField() {
    let filteredOnCompany = [];
    if (
      state.results.searchInput[0].company &&
      state.results.searchInput[0].company.Name.length > 0
    ) {
      if (document.querySelector("#prefilled-term")) {
        getRandomResults();
      } else {
        const searchCategory =
          state.results.searchInput[0].company.searchCategory;
        let objectID = searchCategory
          ? state.results.searchInput[0].company.Id
          : 0;
        switch (searchCategory) {
          case "Companies":
            filteredOnCompany = results.list.filter(
              (company) => company.Id === objectID
            );
            break;
          case "MappingKeywordAttribute":
            if (objectID === 0 || objectID.length === 0) {
              const specName = state.results.searchInput[0].company.Name;
              const specFound = state.search.suggestions.MappingKeywordAttribute.filter(
                (spec) =>
                  spec.Name.toLowerCase().trim() ===
                  specName.toLowerCase().trim()
              );
              objectID = specFound.length > 0 ? specFound[0].Id : 0;
              filteredOnCompany = results.list.filter((company) =>
                company.Specialismen.includes(objectID)
              );
            } else {
              let KwaliteitsregelingenBijSpec = [];

              state.search.suggestions.MappingKeywordAttribute.map((cert) => {
                if (cert.Id === objectID) {
                  KwaliteitsregelingenBijSpec = [
                    ...KwaliteitsregelingenBijSpec,
                    ...cert.auto_kwaliteitsregelingIds.split(","),
                  ];
                }
              });

              KwaliteitsregelingenBijSpec = [
                ...new Set(KwaliteitsregelingenBijSpec),
              ];

              const filterCompanies = results.list.filter((company) => {
                return company.Specialismen !== null
                  ? company.Specialismen.includes(objectID)
                  : -1
              });

              const filteredOnCompanyModified = filterCompanies.map(
                (company) => {
                  let totalRelevantHits = 0;
                  const companyCertificates = company.Kwaliteitreg.split(",");
                  companyCertificates.map((certificate) => {
                    KwaliteitsregelingenBijSpec.includes(certificate)
                      ? totalRelevantHits++
                      : null;
                  });
                  company.relevantScore = totalRelevantHits;
                  return company;
                }
              );

              filteredOnCompany = filteredOnCompanyModified;
            }
            break;
          case "Kwaliteitsregelingen":
            filteredOnCompany = results.list.filter((company) =>
              company.Kwaliteitreg.includes(objectID)
            );
            break;
          default:
            filteredOnCompany = wildcardFilter();
        }

        const sortingBy =
          state.results.searchInput[0].company &&
          state.results.searchInput[0].company.searchCategory ===
            "MappingKeywordAttribute"
            ? "relevant"
            : "";

        const filterList = state.results.latLong.lat
          ? sortResultList("distance", filteredOnCompany)
          : sortResultList(sortingBy, filteredOnCompany);
        setResults({
          ...results,
          list: filterList,
          loaded: true,
          resultStatus: "allDone",
        });
      }
    } else {
      const filterList = state.results.latLong.lat
        ? sortResultList("distance")
        : sortResultList();
      setResults({
        ...results,
        list: filterList,
        loaded: true,
        resultStatus: "allDone",
      });
    }
  }

  function filterOnQualityScheme() {
    const objectID = state.results.searchInput[0].qualityScheme
      ? state.results.searchInput[0].qualityScheme
      : 0;
    if (objectID !== 0) {
      const filteredOnCompany = results.list.filter((company) =>
        company.Kwaliteitreg.includes(objectID)
      );

      setResults({
        ...results,
        list: filteredOnCompany,
        loaded: false,
        resultStatus: "qualitySchemeFiltered",
      });
    } else {
      setResults({
        ...results,
        list: results.list,
        loaded: false,
        resultStatus: "qualitySchemeFiltered",
      });
    }
  }

  function wildcardFilter() {
    const searchFor = state.results.searchInput[0].company.Name.toLowerCase().trim();
    let filteredOnCompanyName = [];
    let filteredOnAltName = [];
    let filteredOnQualityScheme = [];
    let filteredOnSpecialism = [];

    filteredOnCompanyName = results.list.filter((company) =>
      company.Name.toLowerCase().trim().includes(searchFor)
    );

    filteredOnAltName = results.list.filter((company) =>
      company.AltName
        ? company.AltName.toLowerCase().trim().includes(searchFor)
        : null
    );

    const qualitySchemeIDs = state.search.suggestions.Kwaliteitsregelingen.filter(
      (qualityScheme) =>
        qualityScheme.Name.toLowerCase().trim().includes(searchFor)
    ).map((qualityScheme) => qualityScheme.Id);

    qualitySchemeIDs.map((qualitySchemeID) => {
      results.list.filter((company) => {
        const IDs = company.Kwaliteitreg
          ? company.Kwaliteitreg.split(",")
          : null;
        IDs
          ? IDs.map((id) => {
              parseInt(id) === qualitySchemeID
                ? filteredOnQualityScheme.push(company)
                : null;
            })
          : null;
      });
    });

    const specialismIDs = state.search.suggestions.MappingKeywordAttribute.filter(
      (specialism) => specialism.Name.toLowerCase().trim().includes(searchFor)
    ).map((specialism) => specialism.Id);

    specialismIDs.map((specialismID) => {
      results.list.filter((company) => {
        const IDs = company.Specialismen
          ? company.Specialismen.split(",")
          : null;
        IDs
          ? IDs.map((id) => {
              parseInt(id) === specialismID
                ? filteredOnSpecialism.push(company)
                : null;
            })
          : null;
      });
    });
    const combined = [
      ...filteredOnCompanyName,
      ...filteredOnAltName,
      ...filteredOnQualityScheme,
      ...filteredOnSpecialism,
    ];

    const b = [...new Map(combined.map((item) => [item.Id, item])).values()];

    return [...new Map(combined.map((item) => [item.Id, item])).values()];
  }

  function checkForPlace() {
    if (
      state.results.searchInput[0].place &&
      state.results.searchInput[0].place.Name.length > 0
    ) {
      const inputName = state.results.searchInput[0].place.Name;
      const zip = parseInt(inputName.substring(0, 4));
      if (isNaN(zip)) {
        actions.setLatLong({});
      } else if (inputName.indexOf(".") > 0) {
        const latLong = inputName.split(" ");
        actions.setLatLong({
          lat: parseFloat(latLong[0]),
          lng: parseFloat(latLong[1]),
        });
      } else {
        actions.getLatLon(zip);
      }
    } else {
      actions.setLatLong({});
    }
    setResults({
      ...results,
      list: results.list,
      resultStatus: "placeSet",
      loaded: false,
    });
  }

  function filterOnPlaceField() {
    let filteredOnPlace = [];
    if (
      state.results.searchInput[0].place &&
      state.results.searchInput[0].place.Name.length
    ) {
      if (state.results.latLong && state.results.latLong.lat) {
        const distanceRadius = state.results.searchInput[0].distance
          ? state.results.searchInput[0].distance
          : 10;
        const lat = state.results.latLong.lat;
        const long = state.results.latLong.lng;
        filteredOnPlace = state.search.details.filter((value) => {
          if (distance(lat, long, value.Lat, value.Lng) < distanceRadius) {
            return value;
          }
        });
      } else {
        let inputName = state.results.searchInput[0].place.Name;
        inputName =
          inputName.toLowerCase() === "den haag" ? "'s-Gravenhage" : inputName;
        inputName =
          inputName.toLowerCase() === "den bosch"
            ? "'s-Hertogenbosch"
            : inputName;
        const keyForLocation = "Loc.";
        const exactSearch =
          state.results.searchInput[0].place.searchCategory &&
          state.results.searchInput[0].place.searchCategory.length > 0
            ? true
            : false;
        /*if (exactSearch) {
          filteredOnPlace = state.search.details.filter(
            (company) =>
              company[keyForLocation]
                .split(",")[1]
                .toLowerCase()
                .trim() === inputName.toLowerCase().trim()
          );
        } else {
          filteredOnPlace = state.search.details.filter(
            (company) =>
              company[keyForLocation]
                .split(",")[1]
                .toLowerCase()
                .trim()
                .indexOf(inputName.toLowerCase().trim()) > -1
          );
        }*/
        filteredOnPlace = state.search.details.filter(
          (company) =>
            company[keyForLocation].split(",")[1].toLowerCase().trim() ===
            inputName.toLowerCase().trim()
        );
      }
    } else {
      filteredOnPlace = state.search.details;
    }
    setResults({
      ...results,
      list: filteredOnPlace,
      resultStatus: "placesFiltered",
      loaded: false,
    });
  }

  function sortResultList(sortBy, data) {
    let sortedResults;
    let lat, long, dataToSort;
    switch (sortBy) {
      case "name":
        sortedResults = results.list.sort((a, b) =>
          a.Name.localeCompare(b.Name)
        );
        break;
      case "rating":
        sortedResults = results.list.sort((a, b) => {
          b.Rate = b.Rate === null ? "" : b.Rate;
          a.Rate = a.Rate === null ? "" : a.Rate;
          return b.Rate.localeCompare(a.Rate);
        });
        break;
      case "distance":
        dataToSort = data ? data : results.list;
        lat = state.results.latLong.lat;
        long = state.results.latLong.lng;
        sortedResults = dataToSort
          .map((value) => {
            value.distance = distance(lat, long, value.Lat, value.Lng);
            return value;
          })
          .sort((a, b) => a.distance - b.distance);

        break;
      case "relevant":
        dataToSort = data ? data : results.list;
        sortedResults = dataToSort.sort(
          (a, b) => b.relevantScore - a.relevantScore
        );
        break;
      default:
        dataToSort = data ? data : results.list;
        sortedResults = dataToSort.sort(
          (a, b) => b.Kwaliteitreg.length - a.Kwaliteitreg.length
        );
    }
    return sortedResults;
  }

  function checkQualitySchemes() {
    let qualitySchemesFound = [];
    results.list.map(
      (result) =>
        (qualitySchemesFound = [
          ...qualitySchemesFound,
          ...result.Kwaliteitreg.split(",").map((regeling) =>
            parseInt(regeling)
          ),
        ])
    );
    qualitySchemesFound = [...new Set(qualitySchemesFound)];
    const qualitySchemeUsed = state.search.suggestions.Kwaliteitsregelingen.filter(
      (regeling) => qualitySchemesFound.includes(regeling.Id)
    );

    actions.setExtendedSearchQualityScheme(qualitySchemeUsed);
    sessionStorage.setItem(
      "TNLZqualitySchemesFiltered",
      JSON.stringify(qualitySchemeUsed)
    );
  }

  function sortResultsListByOption(e) {
    const sortedResults = sortResultList(
      e.target.selectedOptions[0].getAttribute("data-sort")
    );

    setResults({
      ...results,
      list: sortedResults,
    });
  }

  function getRandomResults() {
    // get 3 random items
    const indexResults = Array.from({ length: 3 }, () =>
      Math.floor(Math.random() * results.list.length)
    );
    const a = [];

    indexResults.map((indexNumber) => a.push(results.list[indexNumber]));

    setResults({
      ...results,
      list: a,
      loaded: true,
      resultStatus: "allDone",
    });
  }

  function activateSearch(e) {
    window.location.href =
      "https://www.technieknederland.nl/ledenzoek-resultaat";
  }

  return (
    <section className="search-results">
      <div className="search-results-header">
        {results.resultStatus !== "allDone" && <p>Bezig met laden</p>}
        {results.resultStatus === "allDone" && !results.landingspage && (
          <div className="total-results">
            <span>
              <strong>{results.list.length}</strong>
              {results.list.length === 0
                ? " resultaten - wijzig uw zoekopdracht"
                : results.list.length > 1
                ? " resultaten"
                : " resultaat"}
            </span>
          </div>
        )}
        {results.list.length > 1 &&
          results.resultStatus === "allDone" &&
          !results.landingspage && (
            <div className="sort-by">
              <span>Sorteren op:</span>
              <select onChange={(e) => sortResultsListByOption(e)}>
                <option>Relevantie</option>
                {state.results.latLong && state.results.latLong.lat && (
                  <option data-sort="distance" selected>
                    Afstand
                  </option>
                )}
                <option data-sort="rating">Waardering</option>
                <option data-sort="name">Naam</option>
              </select>
            </div>
          )}
      </div>
      {results.list.length > 0 && results.resultStatus === "allDone" && (
        <ResultsList list={results.list} />
      )}
      {results.landingspage && (
        <a className="btn" onClick={activateSearch}>
          Bekijk alle vakmensen
        </a>
      )}
    </section>
  );
};

export { Results };

/*
<section className="search-results">
      <div className="search-results-header">
        <div className="total-results">
          <span>
            <strong>{state.results.resultslist.length}</strong>
            {state.results.resultslist.length > 1
              ? " resultaten"
              : " resultaat"}
          </span>
        </div>
        {state.results.resultslist.length > 1 && (
          <div className="sort-by">
            <span>Sorteren op:</span>
            <select onChange={(e) => sortResultList(e)}>
              <option data-sort="relevant">Relevantie</option>
              {state.results.latLong && state.results.latLong[0] && (
                <option data-sort="distance">Afstand</option>
              )}
              <option data-sort="rating">Waardering</option>
              <option data-sort="name">Naam</option>
            </select>
          </div>
        )}
      </div>
      {state.results.resultslist.length > 0 && (
        <ResultsList list={state.results.resultslist} />
      )}
    </section>

    function filterResults() {
    const keyLoc = "Loc.";
    let place;
    let searchResults = [];

    if (
      state.results.searchInput.data.place &&
      state.results.searchInput.data.place.Name
    ) {
      place = state.results.searchInput.data.place.Name.toLowerCase();
      searchResults =
        state.results.searchInput.data.place.searchCategory.length > 0
          ? state.results.Companies.filter(
              (company) =>
                company[keyLoc]
                  .split(",")[1]
                  .trim()
                  .toLowerCase() === place
            )
          : state.results.Companies.filter(
              (company) =>
                company[keyLoc]
                  .split(",")[1]
                  .trim()
                  .toLowerCase()
                  .indexOf(place) > -1
            );
    } else {
      searchResults = state.results.Companies;
    }

    if (state.results.searchInput.data.company) {
      const valueToFind = state.results.searchInput.data.company.Name;
      // check for wildcard
      searchResults =
        state.results.searchInput.data.company.searchCategory.length > 0
          ? filterOnCategory(
              state.results.searchInput.data.company.searchCategory,
              searchResults,
              valueToFind
            )
          : filterOnWildcard(searchResults, valueToFind);
    }
    actions.setResults(searchResults);
  }
    */